export default class Stats
{
	completeness = 0
	rating = 0
	feedback = 0
	label = null

	static Zero = new Stats();
}